import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";
import AddProtocolModal from "../Modal/AddProtocolModal";
import { GetWorkflowProtocol } from "../utilities/WorkFlowUtilities";
import Table from "../ConfigurePages/Table";

const CustomNodeAnonProtocol = ({ id, data, onChange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [AnonData, setAnonData] = useState();
  const [Anon, setAnon] = useState(data);
  const [rules, Setrules] = useState();
  const [editData, setEditData] = useState({});
  const [addNewProtocol, setAddNewProtocol] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    const result = async () => {
      const anonResponse = await fetchAnonProtocols();
      setAnonData(anonResponse?.data?.items);
    };

    result();
  }, []);
  useEffect(() => {
    let id = data?.id;
    const result = async () => {
      const AnonResponse = await GetWorkflowProtocol(id);
      Setrules(AnonResponse?.rules);
    };

    result();
  }, []);

  const handleProtocol = () => {
    setAddNewProtocol((state) => !state);
  };

  const handleAnonChange = (event) => {
    const selectAnon = event.target.value;
    let selectedData = { id: "" };
    if (selectAnon !== "") {
      selectedData =
        AnonData && AnonData.find((p) => p.id === parseInt(selectAnon));
    }
    setAnon(selectAnon);

    if (onChange) {
      onChange(id, selectedData);
    }
  };
  return (
    <>
      <div className="custom-node">
        <div className="node-header">
          PROTOCOL
          <i
            className=" fa fa-plus"
            style={{ marginLeft: "4rem" }}
            onClick={handleProtocol}
          ></i>
        </div>

        {/* <select  value={Anon.id} onChange={handleAnonChange}>
          <option>select</option>
          {AnonData &&
            AnonData.map((data) => (
              <option value={data.id} id={data.id}>
                {data.name}
              </option>
            ))}
        </select> */}

        <div className="name">{data?.name}</div>

        <Handle type="target" position="left" />
        <Handle type="source" position="right" />
      </div>
      {/* <div>
        {" "}
        {addNewProtocol && (
          <AddProtocolModal
            ModalState={addNewProtocol}
            handleClose={handleProtocol}
            // setUpdate={setUpdate}
            editData={editData}
            // handleclickcustom={handleclickcustom}
          />
        )}
      </div> */}
      {addNewProtocol && (
        <Table modal={addNewProtocol} handleClose={handleProtocol} rules={rules} type={'workflow'} />
      )}
    </>
  );
};

export default CustomNodeAnonProtocol;
